import * as types from "../mutation-types";
// state
export const state = {
  course: "",
  id: "",
  slug: "",
};

// mutations
export const mutations = {
  [types.CHANGE_COURSE](state, course) {
    // Object.assign(state, { ...payload })
    state.course = course.course;
    state.id = course.id;
    state.slug = course.slug;
  },
  [types.CLEAR_COURSE](state) {
    // Object.assign(state, { course: null })
    state.course = null;
  },
};

// actions
export const actions = {
  changeCourse({ commit, state }, payload) {
    commit(types.CHANGE_COURSE, payload);
  },
  clearCourse({ commit }) {
    commit(types.CLEAR_COURSE);
  },
  SaveCourseSessions({ commit, state }, payload) {
    commit(types.SAVE_COURSE_SESSIONS, payload);
  },
};
